import classNames from 'classnames';
import { useHelpCenter } from 'hooks/use-help-center';

const topicId = 'blotter.fullTextSearch';

type Props = {
  className?: string;
};

export function AdvancedSearchInfoLink({ className }: Props) {
  const { openTopicId } = useHelpCenter();

  return (
    <button
      type="button"
      className={classNames('btn btn-icon border-start border-opacity-40', className)}
      onClick={() => openTopicId(topicId)}
    >
      <em className="icon icon-sm">info</em>
    </button>
  );
}
